"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Content = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("../context");
const hooks_1 = require("../hooks");
const index_1 = require("./index");
const Content = ({ configState }) => {
    const state = (0, hooks_1.useSearchResultState)(configState);
    if (configState.isZeroResult) {
        return null;
    }
    return ((0, jsx_runtime_1.jsx)(context_1.SearchResultContext.Provider, { value: state, children: state.configData.isDocumentPage ? (0, jsx_runtime_1.jsx)(index_1.Document, {}) : (0, jsx_runtime_1.jsx)(index_1.SearchResultBody, {}) }));
};
exports.Content = Content;
